import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {StatusInfo} from '@catfeatures/types';
import {FeatureServiceCreateInfo} from '@catmodules/models/feature-services/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class FeatureServicesService extends RestHttpService<StatusInfo> {

  constructor(service: Restangular) {
    super('feature-services', service);
  }

  create(item: FeatureServiceCreateInfo): Observable<any> {
    return this.queryAll()
      .post({
        model: item.service._links.self.href,
        unit_type: item.featureUnit._links.self.href,
      })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  /**
   * Updates the feature service from the underlying model.
   * @param id
   */
  updateFromModel(id: any) {
    return this.getRawSubresource(id, 'update');
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-services/services/feature-services.service.ts